import React from 'react';
import { arrayOf, func, object, shape, string } from 'prop-types';

import { Tab } from '@ajaibid/components';

import IconChevron from '@assets/Icon/svg/layout/IconChevron';
import IconExpand from '@assets/Icon/svg/layout/IconExpand';

import useLayout from '@context/layout/useLayout';
import useEventTracker from './tracker/useEventTracker';

import { BOTTOM_TAB } from './constant';
import { styBottomPanelToolBar } from './style';

function BottomPanelToolbar(props) {
  const { instrumentTab, setInstrumentTab } = props;

  const { bottomPanel } = useLayout();
  const { eventCollapseBottomPanel, eventExpandBottomPanel, eventFullScreenBottomPanel } =
    useEventTracker();

  const toggleCollapse = () => {
    if (!bottomPanel.isCollapsed) {
      bottomPanel.collapse();
      eventCollapseBottomPanel();
    } else {
      bottomPanel.show();
      eventExpandBottomPanel();
    }
  };

  const toggleExpand = () => {
    if (!bottomPanel.isExpand) {
      bottomPanel.expand();
      eventFullScreenBottomPanel();
    } else {
      bottomPanel.show();
      // no tracker?
    }
  };

  return (
    <div className={styBottomPanelToolBar}>
      <Tab
        size="md"
        variant="scoped"
        tabOptions={BOTTOM_TAB}
        activeTab={instrumentTab}
        setActiveTab={setInstrumentTab}
      />
      <div>
        <div onClick={toggleCollapse}>
          {bottomPanel.isCollapsed ? <IconChevron.Up /> : <IconChevron.Down />}
        </div>
        <div onClick={toggleExpand}>
          <IconExpand />
        </div>
      </div>
    </div>
  );
}

BottomPanelToolbar.propTypes = {
  instrumentTab: shape({
    key: string,
    name: string,
    tableTab: arrayOf(object),
  }).isRequired,
  setInstrumentTab: func.isRequired,
};

export default BottomPanelToolbar;
